import { DxpError } from './dxp-error';
import { isRecoverable } from './recoverable-error';
import type { UserFacingError } from './user-facing-error.model';

const MESSAGE_KEY_BY_CODE: Readonly<Record<string, string>> = {
  UNAUTHORIZED: 'error.unauthorized',
  FORBIDDEN: 'error.forbidden',
  NOT_FOUND: 'error.notFound',
  API_ERROR: 'error.api',
  ATTACHMENT_TOO_LARGE: 'error.attachmentTooLarge',
  ATTACHMENT_TYPE_NOT_ALLOWED: 'error.attachmentTypeNotAllowed',
  QR_SHEET_EMPTY: 'error.qrSheetEmpty',
};

const GENERIC_MESSAGE_KEY = 'error.generic';
const UNKNOWN_ERROR_CODE = 'UNKNOWN';

export class ErrorCatalog {
  static describe(error: unknown): UserFacingError {
    const code = error instanceof DxpError ? error.code : UNKNOWN_ERROR_CODE;
    const messageKey = MESSAGE_KEY_BY_CODE[code] ?? GENERIC_MESSAGE_KEY;

    return {
      code,
      messageKey,
      severity: 'error',
      ...(isRecoverable(error) ? { recovery: error.recovery } : {}),
    };
  }
}
